import QueryCreditQrCodes from "graphql/queries/QueryCreditQrCodes";
import QueryCreditQrCode from "graphql/queries/QueryCreditQrCode";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder';

const FetchCreditQrCodes = {
	
	fetchAll: ( { callbackSuccess = null, callbackError = null, callbackStart = null, variables = {} } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'credit_qr_codes', QueryCreditQrCodes, {
			variables: variables,
			resultPath: [ 'credit_qr_codes' ],
			callbackStart,
			callbackError,
			callbackSuccess
		})
	},

	fetch: ( { callbackSuccess = null, callbackError = null, callbackStart = null, variables = {} } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'credit_qr_code', QueryCreditQrCode, {
			variables: variables,
			resultPath: [ 'credit_qr_code' ],
			callbackStart,
			callbackError,
			callbackSuccess
		})
	}
}

export default FetchCreditQrCodes
